import type { z } from 'zod'
import type { CamelParams } from '../client'
import { CAMEL_DEFAULT_STALE_TIME, CAMEL_QUERY_KEY_NAMESPACE } from './consts'
import { useCamelClient } from './CamelApiProvider'
import type { CamelQueryDefinition } from './types'

export const camelQueryKey = (path: string, params?: CamelParams): readonly unknown[] => {
  const pathSegments = path.split('/').filter(Boolean)
  return params
    ? [CAMEL_QUERY_KEY_NAMESPACE, ...pathSegments, params]
    : [CAMEL_QUERY_KEY_NAMESPACE, ...pathSegments]
}

export const useCamelQuery = <TData>(
  path: string | null,
  schema: z.ZodType<TData>,
  params?: CamelParams,
): CamelQueryDefinition<TData> => {
  const client = useCamelClient()

  if (path === null)
    return {
      queryKey: [CAMEL_QUERY_KEY_NAMESPACE],
      enabled: false,
      staleTime: CAMEL_DEFAULT_STALE_TIME,
    }

  return {
    queryKey: camelQueryKey(path, params),
    queryFn: async ({ signal } = {}) => schema.parse(await client.get(path, params, signal)),
    enabled: true,
    staleTime: CAMEL_DEFAULT_STALE_TIME,
  }
}
